import request from '@/utils/request';

// 查询预约活动活动概览报表
export const getQueryBookingOverviewReport = (values) => {
  return request('/activityBooking/queryBookingOverviewReport', {
    method: 'POST',
    data: values,
  });
};

// 查询预约活动下单转化率报表(市场，门店)
export const getQueryBookingBuyReport = (values) => {
  return request('/activityBooking/queryBookingBuyReport', {
    method: 'POST',
    data: values,
  });
};

// 查询预约活动核销率报表(市场，门店，场次)
export const getQueryBookingVerificationReport = (values) => {
  return request('/activityBooking/queryBookingVerificationReport', {
    method: 'POST',
    data: values,
  });
};

// 查询预约活动核销率（市场下拉框）
export const getQueryBookingVerificationSalesArea = (values) => {
  return request('/activityBooking/queryBookingVerificationSalesArea', {
    method: 'POST',
    data: values,
  });
};

// 查询预约活动新老会员累计购买报表(市场，门店)
export const getQueryBookingMemberBuyReport = (values) => {
  return request('/activityBooking/queryBookingMemberBuyReport', {
    method: 'POST',
    data: values,
  });
};

// 查询预约活动小程序流转数据报表
export const getQueryBookingDataFlowReport = (values) => {
  return request('/activityBooking/queryBookingDataFlowReport', {
    method: 'POST',
    data: values,
  });
};

// 查询预约活动分布图报表(等级分布，性别分布，年龄分布)
export const getQueryBookingDistributionReport = (values) => {
  return request('/activityBooking/queryBookingDistributionReport', {
    method: 'POST',
    data: values,
  });
};

// 查询预约活动销售品报表
export const getQueryBookingSaleReport = (values) => {
  return request('/activityBooking/queryBookingSaleReport', {
    method: 'POST',
    data: values,
  });
};
